import React from "react";
import * as luxon from "luxon";
import DatePicker, { ReactDatePickerProps } from "react-datepicker";
import { ITheDatePicker } from "interfaces";
import "react-datepicker/dist/react-datepicker.css";

export function TheDatePicker({
  value,
  onChange,
  ...props
}: ITheDatePicker & Omit<ReactDatePickerProps, "value" | "onChange">): React.ReactElement {
  const { readOnly } = props;
  const [isOpen, setIsOpen] = React.useState(false);
  const cast1 = (_value: string | null): Date | null => {
    const date = _value ? luxon.DateTime.fromISO(_value).toLocal() : null;
    return date?.isValid ? date.toJSDate() : null;
  };

  const cast2 = (_value: Date | null): string | null => {
    const date = _value ? luxon.DateTime.fromJSDate(_value) : null;
    return date?.isValid ? date.toISO() : null;
  };

  return (
    <div style={{ zIndex: 100 }}>
      <DatePicker
        open={isOpen}
        onInputClick={() => {
          if (!readOnly) {
            setIsOpen(true);
          }
        }}
        onClickOutside={() => setIsOpen(false)}
        dateFormat="dd/MM/yyyy" // "MMMM d, yyyy h:mm aa"
        locale="en"
        selected={cast1(value)}
        onChange={(_value: Date | null) => {
          if (onChange) {
            onChange(cast2(_value));
          }
        }}
        {...props}
      />
    </div>
  );
}
